export default [
  {
    text: 'option.articles.table.name',
    value: 'name',
    default: true,
  },
  {
    text: 'option.articles.table.description',
    value: 'description',
    default: true,
  },
  {
    text: 'option.articles.table.internalNote',
    value: 'internalNote',
    default: true,
  },
  {
    text: 'option.articles.table.assets',
    value: 'assets',
    type: 'asset',
    default: true,
  },
  {
    text: 'option.articles.table.price',
    value: 'price',
    type: 'decimal',
    default: false,
    editable: true,
  },
  {
    text: 'option.articles.table.sortOrder',
    value: 'sortOrder',
    default: false,
    editable: true,
  },
  {
    text: 'option.articles.table.visible',
    value: 'visible',
    type: 'slot',
    default: true,
  },
  {
    text: 'option.articles.table.active',
    value: 'isActive',
    type: 'slot',
    default: true,
  },
];
